'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reduceVisibleSlides = exports.reduceValidRules = exports.checkVisibility = exports.checkVisibilityRules = exports.sanitizeVisibility = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright (c) 2018 Interacso
 * All rights reserved.
 */

var sanitizeVisibility = exports.sanitizeVisibility = function sanitizeVisibility(visibility) {
  if (Array.isArray(visibility.rules)) {
    return (0, _extends3.default)({}, visibility, {
      rules: visibility.rules.map(function (rule, index) {
        // Evita que la primera regla tenga un operador lógico,
        // por ejemplo al borrar la primera regla desde el editor
        if (index === 0 && rule.logic) {
          return (0, _lodash.omit)(rule, ['logic']);
        }

        return rule;
      })
    });
  }

  return visibility;
};

var visibilityRuleComparision = function visibilityRuleComparision(rule) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var location = props.location,
      _props$forms = props.forms,
      forms = _props$forms === undefined ? [] : _props$forms,
      _props$weathers = props.weathers,
      weathers = _props$weathers === undefined ? [] : _props$weathers,
      _props$query = props.query,
      query = _props$query === undefined ? {} : _props$query;

  var trafficEstimate = props.trafficEstimate || {};
  var sport = props.sport || {};
  var trafficGrabber = props.trafficGrabber || {};
  var languages = props.languages || {};
  var now = (0, _moment2.default)(query.date);
  var operators = { eq: '==', neq: '!=', gte: '>=', lte: '<=', gt: '>', lt: '<', in: 'in', not: 'not' };
  var operator = function operator(r) {
    return operators[r.comparator];
  };
  var comparision = function comparision(r, value) {
    switch (r.comparator) {
      case 'in':
        return '[' + r.value.map(function (v) {
          return '\'' + v + '\',';
        }) + '].includes(\'' + value + '\')';
      case 'not':
        return '![' + r.value.map(function (v) {
          return '\'' + v + '\',';
        }) + '].includes(\'' + value + '\')';
    }
    return [value, operator(r), r.value].join(' ');
  };
  var strComparision = function strComparision(r, value) {
    switch (r.comparator) {
      case 'in':
        return '[' + r.value.map(function (v) {
          return '\'' + v + '\',';
        }) + '].includes(\'' + value + '\')';
      case 'not':
        return '![' + r.value.map(function (v) {
          return '\'' + v + '\',';
        }) + '].includes(\'' + value + '\')';
      case 'neq':
        return '\'' + escape(value) + '\' != \'' + escape(r.value) + '\'';
    }
    return '\'' + escape(value) + '\' == \'' + escape(r.value) + '\'';
  };
  var fc = 'true == false';
  var formComparision = function formComparision(r) {
    var form = forms.find(function (f) {
      return f._id.toString() === r.form;
    });

    if (form) {
      var field = form.fields.find(function (f) {
        return f.key === r.field;
      });

      if (field) {
        switch (field.type) {
          case 'text':
            return strComparision(r, field.value || null);
          case 'number':
            return comparision(r, field.value || null);
          case 'image':
            return strComparision(r, field.value || null);
          case 'video':
            return strComparision(r, field.value || null);
          case 'date':
            return strComparision(r, field.value || null);
          case 'json':
            return strComparision(r, field.value || null);
        }
      }
    }

    return fc;
  };
  var dateComparision = function dateComparision(r, mm, format, dateType) {
    var cDate = mm.startOf(dateType).valueOf();
    var nDate = (0, _moment2.default)(r.value, format).valueOf();
    var vDate = mm.format(format);

    switch (r.comparator) {
      case 'in':
        return '[' + r.value.map(function (v) {
          return '\'' + v + '\',';
        }) + '].includes(\'' + vDate + '\')';
      case 'not':
        return '![' + r.value.map(function (v) {
          return '\'' + v + '\',';
        }) + '].includes(\'' + vDate + '\')';
    }

    return [cDate, operator(r), nDate].join(' ');
  };
  var sportComparision = function sportComparision(r) {
    var live = sport.matchLive && sport.matchLive.find(function (f) {
      return f.id === r.match;
    });
    var match = sport.match && sport.match.find(function (f) {
      return f.id === r.match;
    });

    if (live || match) {
      switch (r.type) {
        case 'newGoal':
          return strComparision(r, live.team);
        case 'winner':
          return strComparision(r, match.winner);
      }
    }
    return fc;
  };

  // TODO: Esto no puede funcionar en el api
  var rotationComparision = function rotationComparision(r) {
    var key = 'rotation-' + r.ref;

    if (typeof window != 'undefined' && window.document) {
      var rotationRaw = localStorage.getItem(key);
      if (rotationRaw) {
        var rotation = JSON.parse(rotationRaw);
        return [r.index, '==', rotation.index].join(' ');
      }
    }

    return 'true';
  };
  var isLocationAvailable = function isLocationAvailable() {
    if (location) {
      return (0, _keys2.default)(location).length > 0;
    }

    return false;
  };

  switch (rule.type) {
    case 'year':
      return comparision(rule, query.year || now.year());
    case 'month':
      return comparision(rule, query.month || now.month() + 1);
    case 'week':
      return comparision(rule, query.week || now.week());
    case 'yearDay':
      return comparision(rule, query.yearDay || now.dayOfYear());
    case 'monthDay':
      return comparision(rule, query.monthDay || now.date());
    case 'weekDay':
      return comparision(rule, query.weekDay || now.day() + 1);
    case 'hour':
      return comparision(rule, query.hour || now.hour());
    case 'minute':
      return comparision(rule, query.minute || now.minute());
    case 'second':
      return comparision(rule, query.second || now.second());
    case 'date':
      return dateComparision(rule, now, 'DD-MM-YYYY', 'day');
    case 'time':
      return dateComparision(rule, now, 'HH:mm', 'minute');
    case 'datetime':
      return dateComparision(rule, now, 'DD/MM/YYYY HH:mm', 'minute');
    case 'location':
      return (isLocationAvailable() ? 'true' : 'false') + ' === ' + (rule.value === true ? 'true' : 'false');
    case 'latitude':
      return location ? comparision(rule, location.latitude) : fc;
    case 'longitude':
      return location ? comparision(rule, location.longitude) : fc;
    case 'province':
      return location ? strComparision(rule, location.province) : fc;
    case 'zone':
      return location ? strComparision(rule, location.zone) : fc;
    case 'community':
      return location ? strComparision(rule, location.community) : fc;
    case 'neightborhood':
      return location ? strComparision(rule, location.neightborhood) : fc;
    case 'address':
      return location ? strComparision(rule, location.address) : fc;
    case 'street':
      return location ? strComparision(rule, location.street) : fc;
    case 'busStation':
      return location ? strComparision(rule, location.busStation) : fc;
    case 'trainStation':
      return location ? strComparision(rule, location.trainStation) : fc;
    case 'subwayStation':
      return location ? strComparision(rule, location.subwayStation) : fc;
    case 'streetNumber':
      return location ? strComparision(rule, location.streetNumber) : fc;
    case 'postalCode':
      return location ? strComparision(rule, location.postalCode) : fc;
    case 'city':
      return location ? strComparision(rule, location.city) : fc;
    case 'district':
      return location ? strComparision(rule, location.district) : fc;
    case 'region':
      return location ? strComparision(rule, location.region) : fc;
    case 'country':
      return location ? strComparision(rule, location.country) : fc;
    case 'temperature':
      return location ? comparision(rule, location.temperature) : fc;
    case 'uv':
      return location ? comparision(rule, location.uv) : fc;
    case 'air':
      return location ? comparision(rule, location.air) : fc;
    case 'pollen':
      return location ? comparision(rule, location.pollen) : fc;
    case 'bsPlayerId':
      return location ? strComparision(rule, location.bsPlayerId) : fc;
    case 'panelId':
      return location ? strComparision(rule, location.panelId) : fc;
    case 'faceId':
      return location ? strComparision(rule, location.faceId) : fc;
    case 'format':
      return location ? strComparision(rule, location.format) : fc;
    case 'furniture':
      return location ? strComparision(rule, location.furniture) : fc;
    case 'connect':
      return location ? strComparision(rule, location.connect) : fc;
    case 'displayUnitId':
      return location ? strComparision(rule, location.displayUnitId) : fc;
    case 'distanceTraffic':
      return strComparision(rule, query.traffic || trafficEstimate.estimate);
    case 'trafficGrabberGroup':
      return comparision(rule, trafficGrabber.group);
    case 'trafficGrabberSOV':
      return comparision(rule, trafficGrabber.sov);
    case 'languageFR':
      return strComparision(rule, languages.fr);
    case 'languageNL':
      return strComparision(rule, languages.nl);
    case 'condition':
      var condition = location ? location.condition : null;

      if (rule.location) {
        var weather = weathers.find(function (w) {
          return w.location === rule.location;
        });

        if (weather) {
          condition = weather.condition;
        }
      }

      return condition ? strComparision(rule, condition) : fc;
    case 'form':
      return formComparision(rule);
    case 'newGoal':
      return sportComparision(rule);
    case 'winner':
      return sportComparision(rule);
    case 'rotation':
      return rotationComparision(rule);
  }
};

var checkVisibilityRules = exports.checkVisibilityRules = function checkVisibilityRules(rules, props) {
  var comparisions = rules.reduce(function (acc, rule) {
    var operators = { and: '&& ', or: '|| ' };
    var comparision = visibilityRuleComparision(rule, props);

    if (rules.length > 1 && rule.logic) {
      comparision = operators[rule.logic] + comparision;
    }

    return acc.concat([comparision]);
  }, []);

  var output = false;

  try {
    output = eval(comparisions.join(' '));
  } catch (e) {
    console.log('Invalid visibility rule', comparisions.join(' '));
  }

  return output;
};

var checkVisibility = exports.checkVisibility = function checkVisibility(props, item) {
  var visibility = sanitizeVisibility(item.visibility);
  var state = visibility.state,
      rules = visibility.rules;


  if (state === 'conditional' && rules && rules.length) {
    return checkVisibilityRules(rules, props);
  }

  return state !== 'hidden';
};

var getValidRules = function getValidRules(item, props) {
  var _item$visibility = item.visibility,
      state = _item$visibility.state,
      rules = _item$visibility.rules;

  var operators = { eq: '==', neq: '!=', gte: '>=', lte: '<=', gt: '>', lt: '<', in: 'in', not: 'not' };

  if (state === 'conditional' && rules && rules.length) {
    if (checkVisibilityRules(rules, props)) {
      var expressions = rules.reduce(function (memo, r) {
        var rule = [r.type, operators[r.comparator], r.value].join(' ');

        if (rules.length > 1 && r.logic) {
          rule = [r.logic, rule].join(' ');
        }

        return memo.concat([rule]);
      }, []);

      return [item.name + ': ' + expressions.join(' ')];
    }
  }

  return [];
};

var reduceValidRules = exports.reduceValidRules = function reduceValidRules(creativity, props) {
  return creativity.slides.reduce(function (memo, slide) {
    return memo.concat(getValidRules(slide, props), slide.elements.reduce(function (els, el) {
      return els.concat(getValidRules(el, props));
    }, []));
  }, []);
};

var reduceVisibleSlides = exports.reduceVisibleSlides = function reduceVisibleSlides(creativity, props) {
  return creativity.slides.filter(function (slide) {
    return checkVisibility(props, slide);
  }).map(function (s) {
    return s.name;
  });
};


//////////////////
// WEBPACK FOOTER
// ../~/d3ck-lib/dist/visibilityRules.js
// module id = 1323
// module chunks = 1